import { type ModuleData, ModuleProvider, useModule } from '#providers'

interface AssetExpensesConfig {
	applicantSessionId: string
	caseId: string
	shouldShowIndicationOfResult: boolean // smartCheckSession.smartCheckConfiguration?.shouldShowIndicationOfResult
	shouldHideAssetBudgets: boolean // smartCheckSession?.smartCheckConfiguration.shouldHideAssetBudgets
	clientInputsType: string // smartCheckSession.clientInputs?.type
}

interface AssetExpensesData {}

export type AssetExpensesModuleData = ModuleData<
	AssetExpensesData,
	void,
	AssetExpensesConfig
>

export const AssetExpensesModuleProvider: typeof ModuleProvider<AssetExpensesModuleData> =
	ModuleProvider

export const useAssetExpensesModule: typeof useModule<AssetExpensesModuleData> =
	useModule
